
import React, { useEffect, useState } from 'react';
import { useOktaAuth, LoginCallback } from '@okta/okta-react';
import { useAuthUser } from '../Hooks/useAuthUser';

const Login = () => {
  const { oktaAuth, authState } = useOktaAuth() || {};
  const [userInfo, setUserInfo] = useState(null);
  const { user } = useAuthUser() || {};
  // Handles login redirect when not authenticated
  useEffect(() => {
    // Prevent multiple auth flows and PKCE error
    if (!authState || authState.isPending) return;
    if (authState.isAuthenticated) {
      setUserInfo(user);
      return;
    }
    // Clear any stale transaction state before starting new login
    oktaAuth.transactionManager.clear();
    oktaAuth.signInWithRedirect();
  }, [authState, oktaAuth, user]);

  if (!authState || authState.isPending) {
    return <LoginCallback />;
  }

  if (authState.isAuthenticated && userInfo) {
    return <div>Welcome, {userInfo.name}</div>;
  }

  return <div>Redirecting to login...</div>;
};

export default Login;
